import { useSearchParams } from 'react-router-dom';

/** Navbar'dagi yil tanlovi `year` search param'ida saqlanadi.
 *  Param bo'lmasa joriy yil qaytadi. */
export const useYearParam = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get('year') || String(new Date().getFullYear());
};
